import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom'

const H1 = styled.h1`
	color: black;
	&:hover{
		cursor: pointer;
	}
`;

const Purple = styled.span`
	color: ${props => props.theme.purple};
`;

const Logo = (props) => {

	return(
		<NavLink to={'/'}>
			<H1>
				bantu<Purple>in</Purple>
			</H1>
		</NavLink>
	);
}

export default Logo;